import Cookies from 'js-cookie';
import RequestUtils from "../utils/request.utils";
const BASE_URL = 'https://www.pivotaltracker.com/services/v5/';

const instance = new RequestUtils(BASE_URL, (header: any) => {
    header['X-TrackerToken'] = Cookies.get('TOKEN');
});

export default instance;
